module.exports = __webpack_public_path__ + "img/employee-salary-setting.d896ddbf.svg";